<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
      <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <!-- <div style="matgin-left:120px;margin-bttom:60px;">成交方式：{{pfxm.pfxmdoneflgCN}}</div> -->
      <el-form :model="pfxm" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div class="row">
          <el-form-item label="顺序号" prop="pfxmseq" verify int :gt="0">
            <el-input v-model="pfxm.pfxmseq" :maxlength="6" :disabled="disable"></el-input>
          </el-form-item>

          <el-form-item label="类型" prop="pfxmflg" verify>
            <el-select v-model="pfxm.pfxmflg" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in pfxmflgList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="成交方式" prop="pfxmdoneflg" verify>
            <el-select v-model="pfxm.pfxmdoneflg" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in pfxmdoneflgList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item> -->
        </div>
        <div class="row">
          <el-form-item label="评分项目" prop="pfxmname" verify>
            <el-input v-model="pfxm.pfxmname" :maxlength="60" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
        <div class="input-append">
          <el-form-item label="百分比" prop="pfxmratio" verify int :gt="0" :lte="leg_pgratio">
            <el-input v-model="pfxm.pfxmratio" :maxlength="5" :disabled="disable">
              <template slot="append">(已分配权重{{pgratiototal}})</template>
            </el-input>
          </el-form-item>
        </div>
        </div>
        <div class="content">
          <el-form-item label="备注">
            <el-input v-model="pfxm.pfxmremark" :maxlength="255" show-word-limit type="textarea" :disabled="disable"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <vggrid v-show="pfxm.pfxmdoneflg === '3' && pfxm.pfxmflg == 2" ref="xGrid" :list="list" tableheight="400" flexname=""
            :cols="cols" :showfooter="false" :showPage="false" :resizable="true"
            :needBlackRow="false" :needPopMenu="true" :canbeEdit="true">
    </vggrid>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  import vggrid from '../common/vggrid'
  const SUCCESS = 1
  export default {
    name: "pfxmForm",
    mixins: [common],
    data () {
      return {
        pfxm: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        pfxmdoneflgList:[],  //成交方式
        pfxmflgList: [],
        list: [],
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80},
          {field: 'pfxmitemseq', fieldtype: 'I', title: '顺序号', calculExpr: '', width: 80},
          {field: 'pfxmitemname', fieldtype: 'C', title: '评分细则', calculExpr: '', editRender: {name: 'input'}},
          {field: 'pfxmitemss', fieldtype: 'F', title: '分值', calculExpr: '', editRender: {name: 'input'}}
        ]
      }
    },
    created () {},
    activated () {
      this.init()
      this.getPgflg()
      this.getPfxmdoneflgList()
      this.getPgItemList()
    },
    watch: {},
    filters: {},
    components: {vggrid},
    computed: {
      pgratiototal () {
        return Number(this.pfxm.pgratiototal ? this.pfxm.pgratiototal:0) + Number(this.pfxm.pfxmratio ? this.pfxm.pfxmratio : 0)
      },
      leg_pgratio () {
        return 100 - Number(this.pfxm.pgratiototal? this.pfxm.pgratiototal : 0)
      }
    },
    deactivated () {
      this.$destroy()
    },
    methods: {
      async init () {
        this.pfxm = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.list = []
      },
      async getPfxmdoneflgList () {
        this.pfxmdoneflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectdoneflg'}
        })
        this.pfxmdoneflgList.forEach(e => {
          if(e.syscodeseq === Number(this.pfxm.pfxmdoneflg)){
            this.pfxm.pfxmdoneflgCN = e.label
          }
        });
      },
      async getPgflg () {
        this.pfxmflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'pgflg'}
        })
      },
      async getPgItemList () {
        // console.log(this.pfxm.pfxmdoneflg === '3' , this.pfxm.pfxmid !== 0)
        if (this.pfxm.pfxmdoneflg === '3' && this.pfxm.pfxmid !== 0) {
          this.list = await request({
            url: '/basic/pfxm/getPgItemList',
            method: "get",
            params: {pfxmid: this.pfxm.pfxmid}
          })
        }
      },
      async addOrEdit () {
        this.btnLoading = true
        if(this.pfxm.pfxmflgPrice && this.pfxm.pfxmflg === '1'){
          this.$message.error('价格项已存在')
          return
        }
        if(this.pfxm.pfxmdoneflg === '1' && this.pfxm.pfxmflg === '2'){
          this.$message.error('价格成交法只能选择价格项！')
          return
        }
        this.submitForm('ruleForm').then(async() => {
          if (this.pfxm.pfxmdoneflg === '3' && this.pfxm.pfxmflg == 2) {
              this.pfxm.pgitems = this.$refs.xGrid.$refs.xGrid.getRecordset()

            } else {
              this.pfxm.pgitems = []
          }
          let data = await request({
            url: '/basic/pfxm/savePg',

            method: "post",
            data: this.pfxm
          })

          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
        this.btnLoading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pfxmIndex'})
      },
      validatePfxmdoneflg(rul, val, callback) {
        this.validateData('该成交方式已存在','pfxmrec','pfxmid','pfxmdoneflg', val, callback)

      },
      validateData (msg,tablename,fieldid,checkfield, checkval, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename,fieldid, checkfield, checkval: this.pfxm[checkfield], id: this.pfxm.pfxmid}
        }).then (res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
    }
  }
</script>


<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 520px;
    }
  }
</style>
